import { render, staticRenderFns } from "./calender-page.vue?vue&type=template&id=37ec94f4&scoped=true&"
import script from "./calender-page.vue?vue&type=script&lang=js&"
export * from "./calender-page.vue?vue&type=script&lang=js&"
import style0 from "./calender-page.vue?vue&type=style&index=0&id=37ec94f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ec94f4",
  null
  
)

export default component.exports